export const QACallCenterPermissions = {
  ViewQaActivitiesWithLeadInfo: {
    components: null,
    componentsId: null,
    permissionsId: 'bca45d17-2833-42b5-5243-08d9918483b8',
    permissionsName: 'View Qa Activities With Lead Info'
  },

  ViewUsersOfQaRoles: {
    components: null,
    componentsId: null,
    permissionsId: 'b7ef98a6-997c-4f10-5244-08d9918483b8',
    permissionsName: 'View Users Of Qa Roles'
  }

};
